/* eslint-disable */
import _ from 'lodash';

import config from './config.data.js';
const defaultConfig = config.development;
const environment =
  typeof process !== 'undefined' && process.env && process.env.NODE_ENV
    ? process.env.NODE_ENV
    : 'development';
const environmentConfig = config[environment] || {};
const finalConfig = _.merge({}, defaultConfig, environmentConfig);

/**
 * Export configuration object
 * This is a public configuration that will be bundled in the client application
 * Do NOT include sensitive data here
 */
export default finalConfig;
